<span #dom data-component-type="link-item">
  <rt-wysiwyg-link />
</span>
